﻿import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils, {
    formatDate,
    parseDate,
} from "react-day-picker/moment";
import moment from "moment";
import { parseDate as parseDateResource } from "../../../../Resources/Scripts/_Shared/parseDate";

import { pushToDataLayer } from "../dataLayer";

import "react-day-picker/lib/style.css";
import "moment/min/locales";

//https://react-day-picker.js.org/examples/input-state
//https://momentjs.com/docs/

export const DateSelectionWithLabel = (props) => {
    const wrappingClass = `single-step__section single-step__section--date ${props.extraClass}`;

    const selectedLocale =
        props.locale === "no"
            ? "nb"
            : props.locale === "se"
              ? "sv"
              : props.locale;
    const format =
        props.country === "no" || props.country === "fi"
            ? "DD.MM.YYYY"
            : "YYYY-MM-DD";

    const addDays =
        props.flexDays !== null
            ? props.flexDays
            : props.country === "no"
              ? 3
              : 7;
    const todaysDate = moment().locale(selectedLocale).format("L");
    const startDate = moment().add(addDays, "days").toDate();
    const endDate = props.endDate
        ? moment(parseDateResource(props.endDate)).toDate()
        : moment().add(1, "year").toDate();

    //const selectedDate = props.value && props.value.date ? moment(new Date(props.value.date)).locale(selectedLocale).format('L') : null;
    const selectedDate =
        props.value && props.value.date
            ? parseDateResource(props.value.date, selectedLocale, "L")
            : null;

    const startSellingDate = props.startSellingDate
        ? moment(startDate).isBefore(
              parseDateResource(props.startSellingDate),
              "day",
          )
            ? moment(parseDateResource(props.startSellingDate)).toDate()
            : null
        : null;

    const settings = {
        firstDayOfWeek: 1,
        month: moment().toDate(),
        fromMonth: moment().toDate(),
        modifiers: {
            disabled: [
                {
                    before: startSellingDate || moment().toDate(),
                },
            ],
        },
    };

    if (!props.showAllDates) {
        settings.month = startDate;
        settings.fromMonth = startDate;
        settings.toMonth = endDate;
        settings.modifiers = {
            disabled: [
                {
                    before: startSellingDate || startDate,
                    after: endDate,
                },
            ],
        };
    }

    if (props.selectedDays) {
        settings.selectedDays = props.selectedDays;
    }

    if (props.disabledDays) {
        settings.disabledDays = props.disabledDays;
    }

    if (props.toMonth) {
        settings.toMonth = props.toMonth;
    }

    if (props.fromMonth) {
        settings.fromMonth = props.fromMonth;
    }

    if (props.month) {
        settings.month = props.month;
    }

    const handleChange = (day) => {
        const dayIsUndefined =
            !props.value.required && props.extraClass
                ? document.querySelector(`.${props.extraClass} input`)?.value
                      ?.length > 0 && day === undefined
                : !!!day;
        const disabledBefore =
            settings.disabledDays?.before ||
            settings.modifiers?.disabled[0]?.before;
        const disabledAfter =
            settings.disabledDays?.after ||
            settings.modifiers?.disabled[0]?.after;

        if (
            (day &&
                ((!props.showAllDates &&
                    moment(day).isBefore(startDate, "day")) ||
                    (disabledBefore &&
                        moment(day).isBefore(disabledBefore, "day")) ||
                    (disabledAfter &&
                        moment(day).isAfter(disabledAfter, "day")))) ||
            dayIsUndefined
        ) {
            props.setValue({
                ...props.value,
                date: null,
                dayOfWeek: null,
                error: props.error || true,
            });
            return;
        }
        pushToDataLayer({
            event: "dateselection_change",
            label: props.text,
            value: day ? moment(day).locale(selectedLocale).format("L") : null,
        });
        const selectedDay = day ? moment(day) : null;
        const dayOfWeek = day ? selectedDay.isoWeekday() - 1 : null;
        props.setValue({
            ...props.value,
            error: null,
            date: day ? selectedDay.locale(selectedLocale).format("L") : null,
            dayOfWeek,
        });
    };

    const handleKeyDown = (e) => {
        if (e.key != "Enter") return;
        document.querySelector(".DayPickerInput input").blur();
    };

    return (
        <div
            className={wrappingClass}
            aria-invalid={props.value.error ? true : null}
        >
            <label>
                {props.text && (
                    <span className="single-step__section__label">
                        {props.text}
                        {props.extraText && <span>{props.extraText}</span>}
                    </span>
                )}
                <DayPickerInput
                    format={format}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    placeholder={props.placeholder ?? todaysDate}
                    onDayChange={handleChange}
                    value={selectedDate}
                    dayPickerProps={{
                        locale: props.language,
                        localeUtils: MomentLocaleUtils,
                        ...settings,
                    }}
                    type="date"
                    hideOnDayClick={true}
                    inputProps={{
                        onBlur: props.onBlur,
                        disabled: props.disabled,
                        locale: selectedLocale,
                        onKeyDown: handleKeyDown,
                    }}
                />
                {props.value.error && (
                    <div className="validation-error">{props.value.error}</div>
                )}
            </label>
            {props.children ? props.children : null}
            {!props.disabled && props.startDateExplanation && addDays > 1 && (
                <p>{props.startDateExplanation.replaceAll("{0}", addDays)}</p>
            )}
            {!props.disabled && props.startDateInfo && (
                <p>{props.startDateInfo}</p>
            )}
        </div>
    );
};
